module.exports = __webpack_public_path__ + "static/media/bill-the-bowman.eb2626e6.jpg";